import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Layout, Space, Spin, notification } from 'antd';
import style from './style.scss';
import FlagRed from '../../../../assets/flag_Red.svg';
import FlagOrange from '../../../../assets/flag_Orange.svg';
import { TM_FRAUD_SOURCE_IDS } from '../../../../util/GlobalConstant';
import TypologyRules from './typologies';
import ListTypologies from '../TypologiesRunInstance/ListTypologies';
import FinalSegments from '../TypologiesRunInstance/FinalSegments';
import FinalSegmentForExecuted from '../TypologiesRunInstance/FinalSegmentForExecuted';

const { Content } = Layout;

const Typologies = ({
  scenarioName,
  scenarioId,
  executed = false,
  scenarioSource,
  preventionAccess,
  typologiesList,
  configureRunInstanceActions,
  liveSets,
  dynpropsTabAccess = false,
  isScenarioLocked = false,
  generationState = 'configuring',
  thresholdResults = null
}) => {
  const [loading, setLoading] = useState(false);
  const [typologySets, setTypologySets] = useState([]);
  const [defaultTypologySets, setDefaultTypologySets] = useState([]);

  useEffect(() => {
    if (typologiesList && typologiesList.length > 0) {
      const mappedTypology = typologiesList.map((t) => ({
        typologyId: t.typology.id,
        typologyName: t.typology.title,
        segmentCombinationIds: t.combinations
          .map((c) => c.id)
          .filter((f) => f !== -1),
        useDefault: t.useDefault
      }));

      setTypologySets([...mappedTypology]);
      setDefaultTypologySets([...mappedTypology]);
    }
  }, [typologiesList]);

  const validateTypologyBeforeSave = () => {
    if (typologySets.filter((f) => f.useDefault).length === 0) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
            &nbsp;&nbsp; {'Error!!'}
          </p>
        ),
        description: 'Please select at least one typology for default segment!'
      });
      return false;
    }

    const selectedCombination = liveSets?.data?.combinations?.filter(
      (combinations) =>
        typologySets.some((typology) =>
          typology.segmentCombinationIds.includes(combinations.id)
        )
    );

    if (
      liveSets?.data?.combinations &&
      selectedCombination.length !== liveSets?.data?.combinations?.length
    ) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
            &nbsp;&nbsp; {'Error!!'}
          </p>
        ),
        description: 'Please select at least one typology for segment sets!'
      });
      return false;
    }

    return true;
  };

  const saveTyplogiesHandler = () => {
    if (!validateTypologyBeforeSave()) {
      return;
    }
    configureRunInstanceActions.saveTypologySegments({
      id: scenarioId,
      data: typologySets
    });
  };

  const getHeader = useMemo(() => {
    const imageSrc =
      scenarioSource === TM_FRAUD_SOURCE_IDS.TM ? FlagOrange : FlagRed;
    const headerSubTitle =
      scenarioSource === TM_FRAUD_SOURCE_IDS.TM
        ? `AML-TM Detection`
        : `Fraud Detection`;
    return (
      <div
        style={{
          paddingLeft: '5px',
          marginLeft: '10px',
          borderLeft: '1px solid #000'
        }}>
        <img style={{ paddingLeft: '5px' }} src={imageSrc} alt="" />{' '}
        {headerSubTitle}
      </div>
    );
  }, [scenarioSource]);

  const isSaveBtnDisabled = useMemo(() => {
    return JSON.stringify(defaultTypologySets) === JSON.stringify(typologySets);
  }, [defaultTypologySets, typologySets]);

  return (
    <Content>
      <Space direction="vertical" className={style.tabPanelSpace}>
        {preventionAccess ? (
          <Content className={style.site_layout_background}>
            <TypologyRules
              scenarioID={scenarioId}
              executed={executed}
              isScenarioLocked={isScenarioLocked}
              generationState={generationState}
              thresholdResults={thresholdResults}
            />
          </Content>
        ) : (
          <Spin spinning={loading}>
            <Content className={style.site_layout_background}>
              <Space
                flex
                style={{ justifyContent: 'space-between', width: '100%' }}>
                <div className={style.instanceTitle}>
                  Run Instance Name: {scenarioName}
                  {getHeader}
                </div>
                <Button
                  onClick={saveTyplogiesHandler}
                  disabled={isSaveBtnDisabled}>
                  Save
                </Button>
              </Space>
              <ListTypologies
                key={scenarioId}
                executed={executed}
                liveSets={liveSets}
                typologiesList={typologiesList}
                typologySets={typologySets}
                scenarioId={scenarioId}
                setLoading={setLoading}
                dynpropsTabAccess={dynpropsTabAccess}
                setTypologySets={setTypologySets}
                configureRunInstanceActions={configureRunInstanceActions}
              />
            </Content>
            {executed ? (
              <FinalSegmentForExecuted
                typologySets={typologySets}
                typologiesList={typologiesList}
              />
            ) : (
              <FinalSegments
                executed={executed}
                liveSets={liveSets}
                typologySets={typologySets}
                setTypologySets={setTypologySets}
              />
            )}
          </Spin>
        )}
      </Space>
    </Content>
  );
};

Typologies.propTypes = {
  scenarioName: PropTypes.string.isRequired,
  scenarioId: PropTypes.number.isRequired,
  dynpropsTabAccess: PropTypes.bool,
  preventionAccess: PropTypes.bool,
  executed: PropTypes.bool,
  scenarioSource: PropTypes.string,
  TypologiesList: PropTypes.array,
  typologySegment: PropTypes.object,
  ConfigureRunInstanceActions: PropTypes.object,
  RunInstanceCategories: PropTypes.object,
  match: PropTypes.object,
  liveSets: PropTypes.object,
  typologiesList: PropTypes.array,
  configureRunInstanceActions: PropTypes.object,
  isScenarioLocked: PropTypes.bool,
  generationState: PropTypes.string,
  thresholdResults: PropTypes.object
};

export default Typologies;
